module.exports = __webpack_public_path__ + "images/backgrounds/river/full.b031ec422c9048f4b6fb.jpg";


//////////////////
// WEBPACK FOOTER
// ./resources/images/backgrounds/river/full.jpg
// module id = jeV2
// module chunks = 24